<now-wbsuche-lib-unterrichtsform-basis-facette
  [id]="'fernunterricht'"
  [label]="'Fernunterricht'"
  [modalId]="'fernunterricht'"
></now-wbsuche-lib-unterrichtsform-basis-facette>
